export const Card = ({ label, icon, activeStatus = false, onClick }) => {
  return (
    <div
      onClick={onClick}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "35px 20px",
        borderRadius: "12px",
        backgroundColor: "#ffffff",
        cursor: "pointer",
        boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
        transition: "border 0.2s ease",
      }}
    >
      {/* Left Section */}
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <div>{icon}</div>
        <span style={{ fontSize: "16px", fontWeight: 500 }}>{label}</span>
      </div>

      {/* Radio */}
      <div
        style={{
          width: "20px",
          height: "20px",
          borderRadius: "50%",
          border: activeStatus ? "6px solid #2563eb" : "2px solid #9ca3af",
        }}
      />
    </div>
  );
};
